import { render, staticRenderFns } from "./ModalConflictSync.vue?vue&type=template&id=e856696a&scoped=true&"
import script from "./ModalConflictSync.vue?vue&type=script&lang=js&"
export * from "./ModalConflictSync.vue?vue&type=script&lang=js&"
import style0 from "./ModalConflictSync.vue?vue&type=style&index=0&id=e856696a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e856696a",
  null
  
)

export default component.exports